import Configurator from "./components/Configurator.vue";
import "./plugins/vuetify";
import store from "./store";
import { mapState } from "vuex";
export default {
  store,
  name: "App",
  components: {
    Configurator
  },

  data() {
    return {
      appDark: false,
      showPopUp: false,
      dontShowAgain: false,
      isInDateRange: false,
      country: ""
    };
  },

  mounted: async function () {
    let cc = await this.$rest.getCountryCode();
    this.country = cc.data;
    const startDate = new Date("2025-12-14"); // Inizio intervallo

    const endDate = new Date("2026-01-06"); // Fine intervallo

    const currentDate = new Date();
    this.isInDateRange = currentDate >= startDate && currentDate <= endDate;
    this.evaluatePopUpVisibility(); // eslint-disable-next-line no-undef

    gtag("config", this.gtagId, {
      custom_map: {
        dimension1: "aste",
        dimension2: "coloreMetalloAste",
        dimension3: "finitura",
        dimension4: "asianFitting",
        dimension5: "coloreFrontale",
        dimension6: "misura",
        dimension7: "finituraAste",
        dimension8: "nomePersonalizzato",
        dimension9: "coloreNomePersonalizzato"
      }
    });
  },
  computed: { ...mapState(["gtagId"]),

    isGuest() {
      return this.$store.getters["configurator/user/isGuest"];
    },

    userCountry() {
      var _this$$store$state$co, _this$$store$state$co2, _this$$store$state$co3;

      return (_this$$store$state$co = this.$store.state.configurator) === null || _this$$store$state$co === void 0 ? void 0 : (_this$$store$state$co2 = _this$$store$state$co.user) === null || _this$$store$state$co2 === void 0 ? void 0 : (_this$$store$state$co3 = _this$$store$state$co2.user) === null || _this$$store$state$co3 === void 0 ? void 0 : _this$$store$state$co3.country;
    }

  },
  methods: {
    evaluatePopUpVisibility() {
      if (this.isGuest || this.userCountry !== "ES") {
        this.showPopUp = false;
        return;
      }

      const dontShow = localStorage.getItem("dontShow");
      this.showPopUp = this.isInDateRange && (!dontShow || dontShow === "false");
    },

    closePopUp() {
      // Salva la preferenza dell'utente nel localStorage
      if (this.dontShowAgain) {
        localStorage.setItem("dontShow", "true");
      }

      this.showPopUp = false;
    },

    changePopUp() {
      this.showPopUp = !this.showPopUp; // Cambia lo stato del popup
    }

  },
  watch: {
    appDark: function (val) {
      this.$vuetify.theme.dark = val;
    },
    isGuest: function () {
      this.evaluatePopUpVisibility();
    },
    userCountry: function () {
      this.evaluatePopUpVisibility();
    }
  }
};